import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Node, NodesParts, NodesTitles } from '../../../../../../types';
import { DismanltingTypeSelect } from '../../../../components';
import { HintText } from '../../style';
import { PartCard } from './components';
import { Arrow, Container, Legend } from './style';

interface Props {
  nodes: Node[];
  nodesParts: NodesParts;
  nodesTitles: NodesTitles;
  setNodes: (nodes: Node[]) => void;
}

export const SelectParts = ({ nodes, nodesParts, nodesTitles, setNodes }: Props) => {
  const { t } = useTranslation();

  const [showLegend, setShowLegend] = useState(true);

  return <Container>
    <Legend opened={showLegend}>
      <Arrow opened={showLegend} onClick={() => setShowLegend(!showLegend)}/>
      <div>
        <span>{t('Part will')}</span>
        <DismanltingTypeSelect value='whole' label='be included in the component'/>
        <DismanltingTypeSelect value='apart' label='be sold separately'/>
        <DismanltingTypeSelect value='missing' label='not be offered for sale'/>
      </div>
    </Legend>
    <div>
      <HintText marginBottom={16}> {t('Determine how you will sell the next major vehicle components - as a whole or as individual parts')}</HintText>
    </div>
    <div>
      {nodes.map((node, i) => <PartCard
        key={i}
        node={node}
        parts={nodesParts[node.name]}
        title={nodesTitles[node.name]}
        updateNode={(value: Partial<Node>) => setNodes([
          ...nodes.slice(0, i), {
            ...nodes[i],
            ...value,
          },
          ...nodes.slice(i + 1),
        ])}
      />)}
    </div>
  </Container>;
};
